import Router from '@/routers';
import { Suspense } from 'react';

import { RootLayout } from './components';
import { useSetLanguage } from './hooks';

const App = () => {
	useSetLanguage();
	return (
		<Suspense fallback={<div className="d-none" />}>
			<RootLayout />
			<Router />
		</Suspense>
	);
};

export default App;
